<template>
  <div
    id="cart-list"
    class="cart-list px-2 ">
    <slot
      name="prepend"/>
    <draggable
      v-bind="dragOptions"
      :animation="100"
      class="list-group"
      :component-data="{ props: { type: 'transition', name: 'flip-list' } }"
      draggable=".card-draggable"
      tag="transition-group"
      :value="computedList"
      @end="renumber($event)">
      <CartCard
        v-for="(listItem, n) in computedList"
        :id="`cart-${n+1}`"
        :key="listItem[keyField]"
        :class="{'card-draggable': draggable }"
        :get-group="getGroup"
        :get-measur="getMeasur"
        :get-name="getName"
        :item="listItem"
        :loading="loading"
        :use-amount="useAmount"
        @delete="$emit('delete', {item: listItem, index: n})">
        <template #item-title="{ item }">
          <slot
            :item="item"
            name="item-title"/>
        </template>
        <template #item-additional="{ item }">
          <slot
            :item="item"
            name="item-additional"/>
        </template>
        <template #item-action="{ item }">
          <slot
            :item="item"
            name="item-action"/>
        </template>
        <template #edit="{ item }">
          <slot
            :index="n"
            :item="item"
            name="edit"/>
        </template>
      </CartCard>
    </draggable>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import CartCard from 'components/common/blocks/CartCard.vue'

import { modalMixin } from 'mixins'

export default {
  name: 'cartList',
  mixins: [ modalMixin],
  data() {
    return {
      menu: false,
      menu_item: '',
      count: 0,
      dragOptions: {
        animation: 15,
        forceFallback: true,
        disabled: !this.draggable,
        ghostClass: 'cart-list-item-ghost',
      },
      // items: []
    }
  },
  props: {
    list: Array,
    /**
     * Поле с уникальным идентификатором эллемента. Без него будет дергатся анимация
     */
    keyField: {
      type: String,
      required: true,
    },
    getMeasur: {
      type: Function,
      default: () => {}
    },
    getGroup: {
      type: Function,
      default: () => {}
    },
    getName: {
      type: Function,
      default: () => {}
    },
    loading: Boolean,
    /**
     * Возможность перетаскивать карточки
     */
    draggable: {
      type: Boolean,
      default: false
    },
    useAmount: {
      type: Boolean
    }
  },
  computed: {
    computedList() {
      return this.list
    }
  },
  methods: {
    renumber(sortObject) {
      let { oldIndex, newIndex } = sortObject

      const result = this.$_.cloneDeep(this.computedList)

      let delta = 1
      let minIndex = newIndex
      let maxIndex = oldIndex
      if (oldIndex < newIndex) {
        delta = -1
        minIndex = oldIndex
        maxIndex = newIndex
      }

      result.forEach((cart, cartIndex) => {
        if (cartIndex >= minIndex && cartIndex <= maxIndex) {
          const lotNumber =  cartIndex === oldIndex
            ? newIndex + 1
            : cart.lotNumber + delta
          cart.lotNumber = lotNumber
        }
      })
      this.$emit('update:list', result)
    },
  },
  components: {
    draggable,
    CartCard
  }
}
</script>
<style lang="scss" scoped>
.card-draggable {
  cursor: all-scroll;
}
.sortable-drag {
  display: none !important;
}
.cart-list-item-ghost {
  opacity: 0.5;
}
.cart-list {
  max-height: calc( 100vh - 160px);
  overflow-y: auto;
  overflow: auto;
}

</style>
<style lang="scss">
.list-group {
  display: grid;
  grid-gap: 8px;
  grid-template-columns: 1fr;
}
.flip-list-move {
  transition: transform 0.5s;
}

.cart-list-options-menu {
  .list-item {
    cursor: pointer;
    display: flex;
    padding: 8px 12px;
    .list-item-icon  {
      margin-right: 8px;
    }
    &:hover {
      background-color: var(--v-secondary__green_chosen-base);
    }
  }
}
</style>
